<div class="k-overlay" *ngIf="editFormActive"></div>
<kendo-window *ngIf="editFormActive" (close)="openDialog()" [state]="windowState"
  [width]="source.value === 'STATIC' ? 1024 : (communityEnabled ? 1200 : 1024)" style="position:fixed" [top]="60"
  [height]="725">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{ (isNew ? 'ADD-ASSESSMENT' : isDeleted ? 'VIEW-ASSESSMENT' : 'EDIT-ASSESSMENT' ) |
        translate }}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <form novalidate [formGroup]="editForm">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab title="{{ 'ASSESSMENT' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="k-form formly-container">
            <!--Assessment Name-->
            <div class="row">
              <div class="col-6">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'NAME' | translate}} *
                  </span>
                  <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                  <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('required') && name.touched"
                    role="alert">
                    {{'REQUIRED-NAME' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('nameExists')" role="alert">
                    {{'ASSESSMENT-ALREADY-EXISTS' | translate}}
                  </div>
                </label>
              </div>
              <!--Assessment Type-->
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ASSESSMENT-TYPE' | translate}} *
                  </span>
                  <kendo-combobox id="type" formControlName="type" class="w-100" [valuePrimitive]="false"
                    [itemDisabled]="itemDisabled" [data]="assessmentTypes" [textField]="'name'" [valueField]="'id'">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" *ngIf="type.hasError('required') && type.touched"
                    role="alert">
                    {{'REQUIRED-ASSESSMENT-TYPE' | translate}}
                  </div>
                </label>
              </div>
              <!--Assessment Version-->
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'VERSION' | translate}} *
                  </span>
                  <input id="assessmentVersion" kendoTextBox formControlName="assessmentVersion" maxlength="20" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="assessmentVersion.hasError('required') && assessmentVersion.touched">
                    {{'REQUIRED-ASSESSMENT-VERSION' | translate}}
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <!--Assessment Description-->
              <div class="col-6">
                <label for="description" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'DESCRIPTION' | translate }} *
                  </span>
                  <textarea kendoTextArea class="w-100" rows="1" formControlName="description" maxlength="1000">
                  </textarea>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="description.hasError('required') && description.touched">
                    {{'REQUIRED-DESCRIPTION' | translate}}
                  </div>
                </label>
              </div>
              <!--Sensitivity Flags-->
              <div class="col-6">
                <label for="sensitivities" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'RESTRICTED-DATA-REASONS' | translate }}
                  </span>
                  <kendo-multiselect id="sensitivities" [data]="sensitivitiesFiltered" formControlName="sensitivities"
                    [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                    (filterChange)="filterSensitivities($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualSensitivity" style="max-height: 137px; overflow: auto;">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                </label>
              </div>
            </div>
            <div class="row">
              <!--Assessment Source-->
              <div class="col-6">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ASSESSMENT-SOURCE' | translate}} *
                  </span>
                  <div>
                    <span style="position: relative;left: 20%;">
                      <input type="radio" value="STATIC" name="source" formControlName="source" id="radioStatic"
                        kendoRadioButton />
                      <label class="k-radio-label" for="radioStatic"
                        [ngClass]="{'k-disabled': source.disabled}">{{'ASSESSMENT-SOURCE-STATIC' | translate}}
                      </label>
                      <input type="radio" value="FORM" name="source" formControlName="source" id="radioForm"
                        kendoRadioButton /><label class="k-radio-label" for="radioForm"
                        [ngClass]="{'k-disabled': source.disabled}">{{'ASSESSMENT-SOURCE-FORM' | translate}}
                      </label>
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="source.hasError('required') && source.touched">
                        {{'REQUIRED-SOURCE' | translate}}
                      </div>
                    </span>
                  </div>
                </label>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-5">
                    <!--Channel Only-->
                    <div class="mt-3">
                      <label class="k-text-uppercase dark mr-2 w-100" for="workflowOnly">
                        {{ 'CHANNEL-ONLY' | translate }}
                      </label>
                      <kendo-switch formControlName="workflowOnly" onLabel="{{'YES' | translate }}"
                        offLabel="{{'NO' | translate }}">
                      </kendo-switch>
                    </div>
                  </div>
                  <div class="col-7">
                    <!--Show Member Extensions-->
                    <div class="mt-3">
                      <label class="k-text-uppercase dark mr-2 w-100" for="showMemberExtension">
                        {{ 'SHOW-MEMBER-EXTENSIONS' | translate:patientLabel }}
                      </label>
                      <kendo-switch formControlName="showMemberExtension" onLabel="{{'YES' | translate }}"
                        offLabel="{{'NO' | translate }}">
                      </kendo-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Access-->
            <div class="row">
              <div class="col-3">
                <div class="mt-3">
                  <!--Enabled-->
                  <label class="k-text-uppercase dark mr-2 w-100" for="active">{{ 'ENABLED' | translate }}
                  </label>
                  <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                  </kendo-switch>
                </div>
              </div>
              <div class="col-3">
                <div class="mt-3">
                  <label class="k-text-uppercase dark mr-2 w-100" for="privateAssessment">
                    {{ 'PRIVATE' | translate }}<span class="ml-1" style="display: inline-flex">
                      <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(tooltipPrivate)" (mouseover)="showTooltip(tooltipPrivate)"
                        (blur)="hideTooltip()" (mouseout)="hideTooltip()" aria-live="polite">
                        <a #tooltipPrivate title="{{'ASSESSMENT-PRIVATE-TOOLTIP' | translate}}">
                          <i class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </label>
                  <kendo-switch formControlName="privateAssessment" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                  </kendo-switch>
                </div>
              </div>
              <div class="col-6" *ngIf="privateAssessment.value">
                <span class="k-text-uppercase dark k-form-field">{{'STAFF' | translate}}</span>
                <kendo-grid [data]="view.gridData" [hideHeader]="true" (cancel)="staffCancelHandler($event)"
                  [pageable]="false" (save)="staffSaveHandler($event)" (add)="staffAddHandler($event)"
                  [navigable]="true" (dataStateChange)="dataStateChange($event)" style="max-height:152px">
                  <kendo-grid-messages noRecords="{{ 'NO-STAFF' | translate }}">
                  </kendo-grid-messages>
                  <kendo-grid-column field="name" [width]="70">
                    <ng-template kendoGridEditTemplate>
                      <kendo-combobox id="staffDropdown" [data]="staffCandidatesFiltered" [textField]="'name'"
                        [valueField]="'id'" [filterable]="true" (filterChange)="filterStaffCandidates($event)"
                        (close)="searchTerm=''" [(value)]="newStaffMember" [itemDisabled]="userItemDisabled">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                          <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                          </span>
                        </ng-template>
                      </kendo-combobox>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span [ngClass]="{'disabled-record-text': !dataItem.enabled || dataItem.deleted,
                                    'k-text-line-through': dataItem.deleted}">{{dataItem.name}}</span>&nbsp;<span
                        class="disabled-record-text">{{setRecordStateText(dataItem)}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-command-column [width]="30" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <ng-container *ngIf="!dataItem.editing">
                        <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                          (click)="deleteStaff(dataItem)"></i>
                      </ng-container>
                      <ng-container *ngIf="dataItem.editing">
                        <ng-container *ngIf="newStaffMember !== null && newStaffMember !== undefined">
                          <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                            (click)="staffSaveButton.click.emit($event); dataItem.editing = false;">
                          </i>
                          &nbsp;
                        </ng-container>
                        <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                          (click)="staffCancelButton.click.emit($event); dataItem.editing = false;"></i>
                        <button kendoGridSaveCommand #staffSaveButton class="d-none"></button>
                        <button kendoGridCancelCommand #staffCancelButton class="d-none"></button>
                      </ng-container>
                    </ng-template>
                  </kendo-grid-command-column>
                  <button kendoGridAddCommand #staffAddButton class="d-none"></button>
                </kendo-grid>
                <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3"
                  (click)="staffAddButton.click.emit($event)">
                  {{'ADD' | translate}}<i class="far fa-user-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ getTabTitle() | translate }}" *ngIf="source.value">
        <ng-template kendoTabContent>
          <!--Static Template-->
          <div class="k-form" *ngIf="source.value === 'STATIC'">
            <!--Assessment File Name-->
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FILENAME' | translate}} *
                  </span>
                  <input id="documentName" kendoTextBox formControlName="documentName" />
                  <input class="d-none" type="file" (change)="onFileChanged($event)" #fileInput>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="documentName.hasError('required') && documentName.touched">
                    {{'ASSESSMENT-FILE-REQUIRED' | translate}}
                  </div>
                  <button appPreventClick *ngIf="!isDeleted" kendoButton type="button" (click)="fileInput.click()"
                    class="mt-3 float-right">
                    {{'SELECT-ASSESSMENT-TEMPLATE' | translate}}<i class="far fa-upload fa-white"></i>
                  </button>
                </label>
              </div>
            </div>
          </div>
          <!--Form Template Designer-->
          <div *ngIf="source.value === 'FORM'">
            <app-formly-designer (fieldsChanged)="fieldsChanged($event)" (flagsChanged)="flagsChanged($event)"
              (tasksChanged)="tasksChanged($event)" (serviceTypesChanged)="serviceTypesChanged($event)"
              (channelsChanged)="channelsChanged($event)" (needsChanged)="needsChanged($event)" [model]="model"
              [fields]="fields" [flags]="flags" [tasks]="tasks" [serviceTypes]="serviceTypes" [channels]="channels"
              [needs]="needs" [isDeleted]="isDeleted" [assessmentId]="assessmentId"
              [consentTypeAssessment]="type?.value?.consentType || false">
            </app-formly-designer>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
  <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
    <button *ngIf="!isDeleted && selectedTab === 0" class="k-button" (click)="onImportSetup()"
      style="position:absolute;left:15px">{{ 'IMPORT' | translate }}<i class="far fa-file-import"></i>
    </button>
    <button *ngIf="!isDeleted" class="k-button" (click)="openDialog()">{{ 'CANCEL' | translate }}</button>
    <button *ngIf="isDeleted" class="k-button" (click)="openDialog()">{{ 'CLOSE' | translate }}</button>
    <button appPreventClick *ngIf="!isDeleted" class="k-button k-primary"
      [disabled]="!editForm.valid || !editForm.dirty || !flagsFormValid || !tasksFormValid || !serviceTypesFormValid || !channelsFormValid || !needsFormValid"
      (click)="onSave($event)">{{ 'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-window>

<!--Close confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="dialogVisible" (close)="cancelSave(false)"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-ADD-ASSESSMENT-CLOSE' | translate }}</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelSave(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="cancelSave(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-upload class="d-none" [autoUpload]="false" [multiple]="false" (select)="onFileImportChanged($event)">
</kendo-upload>